const statisticsCheckins = {
  en: {
    translation: {
      checkins_by_customers_title: "Check-in completed by your customers",
      checkins_in_your_business: "Check-in completed in your business",
      checkins_other_business:
        "Check-in completed in other businesses by your customers",
      customers_actions: "Customers actions",
      your_customers: "Your customers",
      checkins_on_foodies: "Check-in/Foodies",
      checkins_on_foodies_description:
        "Higher check-in/foodies value corresponds to higher loyalty",
      customer_value: "Customer value",
      checkin_rate: "Check-in rate",
      checkin_completed: "Completed: ",
      checkin_left: "Not completed: ",
      engagement_rate: "Engagement rate",
      engagement_rate_app: "Engagement rate in app",
      not_engagement_description:
        "Users who viewed your page not belonging to your area of reference (they are more than 250 m away from your business area)",
      engagement_description:
        "Percentage of people who viewed your page in a range of 250 m away from your business. They can be potential customers if intercepted with a targeted geo-marketing campain.  ",
      customers_value_1: "Your customers also completed ",
      customers_value_2: " check-in for a total expense of ",
      customers_value_title: "spent in your business",
      other_categories_title:
        "Your customers have completed check-ins in other types of business",
      other_categories_description:
        "Check-ins completed by your customers in businesses with categories different from yours. This will help you understand your customers type and retarget your customers",
      checkin_days_text: "Make your customers do a check-in in your business",
      total_customers: "All customers: ",
      returning_customers: "Returning customers",
      new_customers: "New customers",
      checkins_chart_tooltip_description:
        "Total check-ins, completed by your customers in other businesses",
      customers_activities_tooltip:
        "This is the average expenditure that each of your customers makes in the other businesses. It helps to understand the financial resources of your customers and to refocus prices",
      customers_value_tooltip_description:
        "Completed Check-ins and money spent by your customers in your business",
      returning_customers_tooltip:
        "The increase in returning customers is a good sign. It means that you are building customer loyalty: you have hit your target and you are working well"
    }
  },
  it: {
    translation: {
      checkins_by_customers_title: "Check-in completati dai tuoi clienti",
      checkins_in_your_business: "Check-in effettuati nel tuo locale",
      checkins_other_business:
        "Check-in effettuati dai tuoi clienti in altri locali",
      customers_actions: "Attività clienti",
      your_customers: "I tuoi clienti",
      checkins_on_foodies: "Check-in/Foodies",
      checkins_on_foodies_description:
        "Ad un più alto valore check-in/Foodies corrisponde una maggiore fidelizzazione",
      customer_value: "Valore cliente",
      checkin_rate: "Tasso check-in",
      checkin_completed: "Completati: ",
      checkin_left: "Abbandonati: ",
      engagement_rate: "Tasso di coinvolgimento",
      engagement_rate_app: "Tasso di coinvolgimento in app",
      not_engagement_description:
        "Utenti che hanno visualizzato la tua pagina non appartenenti alla tua zona di riferimento (sono distanti più di 250 m dal tuo locale)",
      engagement_description:
        "Percentuale di persone che, trovandosi al massimo a 250 m di distanza dal tuo locale, hanno visualizzato la tua pagina. Sono possibili clienti, intercettabili con una campagna di geo-marketing mirata.",
      customers_value_1: "I tuoi clienti hanno inoltre completato ",
      customers_value_2: " check-in per una spesa di ",
      customers_value_title: "spesi nella tua struttura",
      other_categories_title:
        "I tuoi clienti hanno completato check-in anche in altre strutture",
      other_categories_description:
        "Check-in completati dai tuoi clienti in altre strutture con categorie differenti dalla tua. Questo dato ti aiuterà a comprendere il tuo tipo di clientela e a ricentrare il target",
      checkin_days_text:
        "Incentiva i tuoi clienti ad effettuare check-in all'interno della tua struttura",
      total_customers: "Clienti totali: ",
      returning_customers: "Di ritorno",
      new_customers: "Per la prima volta nel tuo locale",
      checkins_chart_tooltip_description:
        "Check-in totali, effettuati dai tuoi clienti in altri locali",
      customers_activities_tooltip:
        "Si tratta della spesa media che ogni tuo cliente fa negli altri locali. Aiuta a capire le disponibilità economiche della tua clientela e a ricentrare i prezzi",
      customers_value_tooltip_description:
        "Check-in completati e soldi spesi dai tuoi clienti all'interno del tuo locale",
      returning_customers_tooltip:
        "L'aumento di clienti di ritorno sono un ottimo segnale. Vuol dire che stai fidelizzando la clientela: hai centrato il target e stai lavorando bene"
    }
  }
};

export default statisticsCheckins;
